module.exports = __webpack_public_path__ + "img/adv4.1d79c290.svg";